<template>
  <v-system-bar dark color="primary" fixed class="pa-4">
    <v-spacer></v-spacer>
    <v-btn text color="white" small>
      <v-icon color="white" small>mdi-phone</v-icon>
      (011)-5370-0873
    </v-btn>
    <v-btn text color="white" small>
      <v-icon color="white" small>mdi-email</v-icon>
      info@argecam.com.ar
    </v-btn>
    <v-divider vertical></v-divider>
    <v-btn icon href="https://www.instagram.com/argecam.srl/" target="_blank">
      <v-icon color="white" small class="ma-0">mdi-instagram</v-icon>
    </v-btn>
    <v-btn
      icon
      href="https://www.facebook.com/Argecam-SRL-279391785494145"
      target="_blank"
    >
      <v-icon color="white" small class="ma-0">mdi-facebook</v-icon>
    </v-btn>
  </v-system-bar>
</template>

<script>
export default {
  name: "system-bar"
};
</script>

<style></style>
